<template>
  <div v-if="delegate" class="tracking_indicator">
    <div class="tracking_content">
      <img
        :src="delegate.avatar || defaultAvatar"
        alt="avatar"
        class="tracking_avatar"
      />
      <div class="tracking_info">
        <span class="tracking_label">{{ $t("PLACEHOLDERS.tracking") }}</span>
        <span class="tracking_name" @click="$emit('open-delegate', delegate.id)">
          {{ delegate.name }}
        </span>
      </div>
      <button class="stop_tracking_btn" @click="$emit('stop')">
        <i class="fas fa-times"></i>
        {{ $t("BUTTONS.stop_tracking") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DelegatesTrackingBar",

  props: {
    delegate: {
      type: Object,
      default: null,
    },
    defaultAvatar: {
      type: String,
      required: true,
    },
  },
};
</script>
